export default __webpack_public_path__ + "quote-mark@3x-fcQ.png";